export const loginTitleFont = 'Poppins-Regular' //login title font for example
export const mainMenuHeaderTextFont = 'Roboto-Regular' //nav menu main font
export const mainMenuHeaderSubTextFont = 'Ubuntu-Regular' //nav menu sub font

export const primaryFont = 'Montserrat-Regular' // used as fontFamily commonly.
